import { useNativeActions } from "@/utils/useNativeActions";

export const useAddressDialog = (
  openWebAddressModal: (isOpen: boolean) => void
) => {
  const { isCmaApp, openAddressDialog } = useNativeActions();

  const openAddressFlow = () => {
    if (isCmaApp) {
      openAddressDialog();
    } else {
      openWebAddressModal(true);
    }
  };

  return openAddressFlow;
};
